export const FORBIDDEN_SEARCH_CHARS = /[$><=;+]/g;

export const DEFAULT_SEARCH_INPUT_NAME = 'search-input';
